import React from "react";

import "./DashboardsCliente.css";
import { ClientePageShell } from "../../../components/ClientePageShell";
import { GraficoLinha } from "../../../components/Graficos/GraficoLinha";
import { gerarNumerosAleatorios } from "../../Gestor/DashboardsGestor/functions";

const DashboardsCliente = () => {
    const labelsMeses = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

    return (
        <ClientePageShell
            className="dashboards-cliente-page"
            eyebrow="Indicadores"
            title="Dashboards"
            subtitle="Acompanhe indicadores consolidados da sua posição e evolução de rentabilidade."
        >
            <section className="dashboards-cliente-grid">
                <article className="dashboards-cliente-chart">
                    <GraficoLinha
                        dadosGrafico={gerarNumerosAleatorios(1, 4500, labelsMeses.length)}
                        labels={labelsMeses}
                        nomeDado="Cotas"
                        tituloGrafico="Posição em cotas"
                    />
                </article>
                <article className="dashboards-cliente-chart">
                    <GraficoLinha
                        dadosGrafico={gerarNumerosAleatorios(1, 4500, labelsMeses.length)}
                        labels={labelsMeses}
                        nomeDado="Variação em Real"
                        tituloGrafico="Posição em R$"
                    />
                </article>
                <article className="dashboards-cliente-chart">
                    <GraficoLinha
                        dadosGrafico={gerarNumerosAleatorios(1, 4500, labelsMeses.length)}
                        labels={labelsMeses}
                        nomeDado="Periodo"
                        tituloGrafico="Rentabilidade por período"
                    />
                </article>
            </section>
        </ClientePageShell>
    );
};

export default DashboardsCliente;
